/**
 * useCard hook.
 */
import AddonCard from '@components/elements/card/ui/cards/addonCard';
import CharacterCard from '@components/elements/card/ui/cards/characterCard';
import CleanCard from '@components/elements/card/ui/cards/cleanCard';
import EpgCard from '@components/elements/card/ui/cards/epgCard';
import EventCard from '@components/elements/card/ui/cards/eventCard';
import HorizontalCard from '@components/elements/card/ui/cards/horizontalCard';
import KeepWatchingCard from '@components/elements/card/ui/cards/keepWatchingCard';
import RankingPhotoCard from '@components/elements/card/ui/cards/rankingPhotoCard';
import RankingPosterCard from '@components/elements/card/ui/cards/rankingPosterCard';
import VerticalCard from '@components/elements/card/ui/cards/verticalCard';
import SquareCard from '@components/elements/card/ui/cards/squareCard';
import Rail from '@shared/classes/rail';
import { RailDisplayMode, RailType } from '@shared/types/enums/rail';

/**
 * Hook for the card component. Based on the rail display mode, it returns the appropriate card component.
 */
export default function useCard(rail: Rail) {
  let Card = HorizontalCard;
  let vertical = false;
  switch (rail.displayMode) {
    case RailDisplayMode.SQUARE:
      Card = SquareCard;
      break;
    case RailDisplayMode.ADDON_PHOTO:
      Card = AddonCard;
      break;
    case RailDisplayMode.CLEAN_PHOTO:
      Card = CleanCard;
      break;
    case RailDisplayMode.CHARACTER:
      Card = CharacterCard;
      break;
    case RailDisplayMode.CHANNEL_GUIDE_PHOTO:
    case RailDisplayMode.PHOTO:
      if (
        rail?.type === RailType.EVENT ||
        rail?.type === RailType.GUIDE_CHANNEL
      ) {
        Card = EventCard;
      } else if (rail?.type === RailType.KEEP_WATCHING) {
        Card = KeepWatchingCard;
      }
      break;
    case RailDisplayMode.EPG:
      Card = EpgCard;
      break;
    case RailDisplayMode.POSTER:
      Card = VerticalCard;
      vertical = true;
      break;
    case RailDisplayMode.RANKING_PHOTO:
      Card = RankingPhotoCard;
      break;
    case RailDisplayMode.RANKING_POSTER:
      Card = RankingPosterCard;
      vertical = true;
      break;
  }
  return { Card, vertical };
}
